// Internal Module Imports
import { BASE_URL_BIDDING_SERVICE } from '../../../constants';
import { HttpClient } from '../../../utils/httpClient';

const PATH = {
    get: `/${BASE_URL_BIDDING_SERVICE}/common/license-type`,
};

const GetLicenseForCustomer = (customerId, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.get}/${customerId}`).then(callback).catch(error).finally(next);
};

export const LicenseTypeService = {
    GetLicenseForCustomer,
};
